// loading
window.addEventListener('load', () => {
  const spinner = document.getElementById('loading');
  if (!spinner) return;
  spinner.classList.add('loaded');
  spinner.setAttribute('aria-busy', 'false');
  document.documentElement.style.overflow = ''; // ロード中にoverflowを固定してた場合の解除
});
// loading

$(function() {
    $('.menu-btn').click(function() {
        $(this).toggleClass('active');
 
        if ($(this).hasClass('active')) {
            $('.gnavi__sp-style').addClass('active');
        } else {
            $('.gnavi__sp-style').removeClass('active');
        }
    });
});

// top link
	jQuery(function() {
    var pagetop = $('#page_top');   
    pagetop.hide();
    $(window).scroll(function () {
        if ($(this).scrollTop() > 100) {  //100pxスクロールしたら表示
            pagetop.fadeIn();
        } else {
            pagetop.fadeOut();
        }
    });
  $('a[href^="#"]').click(function(){
    var time = 500;
    var href= $(this).attr("href");
    var target = $(href == "#" ? 'html' : href);
    var distance = target.offset().top;
    $("html, body").animate({scrollTop:distance}, time, "swing");
    return false;
  });
});

// top link

// Responsive Menu
var menu = $('.triple');
var nav = $('header nav');
var navClose = $('header .close a');
menu.on('click',function(e){
	e.stopPropagation();
	$(this).toggleClass('open');
	nav.slideToggle(100);
});
navClose.on('click',function(){
	if(menu.hasClass('open')){
		menu.removeClass('open');
		nav.slideUp(100);
	}
});

// header--sticky
window.addEventListener('scroll', function() {
  const header = document.querySelector('.header');
  const headerHeight = header.offsetHeight; // ヘッダーの高さを取得
  const scrollY = window.pageYOffset;
  
  if (scrollY >= 100) {
    header.classList.add('header--sticky');
    document.body.style.marginTop = headerHeight + 'px'; // コンテンツにヘッダーの高さ分の余白を設定
  } else {
    header.classList.remove('header--sticky');
    document.body.style.marginTop = '0'; // コンテンツの余白をリセット
  }
});

// 画像選択のコールバック（例）
frame.on('select', function () {
  const a = frame.state().get('selection').first().toJSON();
  // フルサイズがあればそれを、なければ通常のURL
  const url = (a.sizes && a.sizes.full) ? a.sizes.full.url : a.url;
  const target = $(thisButton).data('target'); // 既存の取得方法に合わせて
  $('#' + target).val(url).trigger('change');
});

// assets/js/admin-site-info.js
(function ($) {
  // 画像選択ボタン（<button class="upload-btn" data-target="archive_img">…）
  $(document).on('click', '.upload-btn', function (e) {
    e.preventDefault();

    var $btn     = $(this);
    var targetId = $btn.data('target'); // 入力の id

    var frame = wp.media({
      title: '画像を選択',
      multiple: false,
      library: { type: 'image' },
      button: { text: '決定' }
    });

    frame.on('select', function () {
      var a = frame.state().get('selection').first().toJSON();
      // ★ full サイズを最優先、無ければ通常URL
      var url = (a.sizes && a.sizes.full) ? a.sizes.full.url : a.url;
      $('#' + targetId).val(url).trigger('change');
    });

    frame.open();
  });

  // クリアボタンがあるなら（任意）
  $(document).on('click', '.clear-btn', function (e) {
    e.preventDefault();
    $('#' + $(this).data('target')).val('').trigger('change');
  });
})(jQuery);